import { graphql } from "react-relay";
import { Environment } from "relay-runtime";

import {
  commitMutationPromiseNormalized,
  createMutation,
  MutationInput,
} from "coral-framework/lib/relay";

import { RejectImageMutation as MutationTypes } from "coral-admin/__generated__/RejectImageMutation.graphql";

let clientMutationId = 0;

const RejectImageMutation = createMutation(
  "rejectImage",
  (environment: Environment, input: MutationInput<MutationTypes>) =>
    commitMutationPromiseNormalized<MutationTypes>(environment, {
      mutation: graphql`
        mutation RejectImageMutation($input: RejectCommentImageInput!) {
          rejectImage(input: $input) {
            comment {
              id
              images {
                id
                url
                status
                reasons
              }
              ...ModerateCardContainer_comment
            }
          }
        }
      `,
      variables: {
        input: {
          commentID: input.commentID,
          imageID: input.imageID,
          clientMutationId: (clientMutationId++).toString(),
        },
      },
    })
);

export default RejectImageMutation;
